import { withKeys as _withKeys, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b49a090"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "input-icon form-floating" }
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "£", -1))
const _hoisted_5 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        ref: "textInput",
        type: "text",
        placeholder: "value",
        id: $props.elementId,
        onKeypress: _cache[0] || (_cache[0] = ($event: any) => ($setup.inputValidator.checkNumeric($event))),
        onMousedown: _cache[1] || (_cache[1] = ($event: any) => ($options.onMousedown())),
        onMouseup: _cache[2] || (_cache[2] = ($event: any) => ($options.onMouseup($event))),
        onFocus: _cache[3] || (_cache[3] = ($event: any) => ($options.gotfocus($event))),
        onBlur: _cache[4] || (_cache[4] = ($event: any) => ($options.lostfocus())),
        class: "form-control",
        value: $props.currentValue,
        onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => ($options.onEnterPressed()), ["enter"]))
      }, null, 40, _hoisted_3),
      _hoisted_4,
      _createElementVNode("label", { for: $props.elementId }, _toDisplayString($props.description), 9, _hoisted_5)
    ])
  ]))
}